import AGENCY_API from '@/api/agencyContract/index';
import { COMPANY_CODE1 } from '@/constants';
export const baseForm = (ctx) => {
  let customerExtraData = {
    companyCode: ctx.baseFormData.contractBusinessCompanyNo,
    departmentCode: ctx.baseFormData.contractBusinessDepartment,
    partnerTypes: 'HZHB01,HZHB03,HZHB11,HZHB10',
  };
  customerExtraData.partnerCodeList = ctx.filterPartnerCodeList;
  if (customerExtraData?.partnerCodeList && customerExtraData.partnerCodeList.length) {
    customerExtraData.associatedPartnerCodeSearch = '1';
  } else {
    customerExtraData.associatedPartnerCodeSearch = '';
  }

  return [
    {
      prop: 'contractCreateDate',
      name: '制单日期',
      type: 'date',
      disabled: true,
      placeholder: '自动生成',
    },
    {
      prop: 'contractNo',
      name: '合同编号',
      type: 'input',
      disabled: true,
      placeholder: '自动生成',
    },
    {
      prop: 'contractName',
      name: '合同名称',
      type: 'input',
      // disabled: cs != '' && cs != 'ZT06' && cs != 'ZT05' && cs != 'ZT061',
      placeholder: '请输入合同名称',
    },
    {
      prop: 'contractBusinessCompanyNo',
      name: '公司',
      type: 'select',
      options: ctx.companyList,
      // disabled: cs == 'ZT02' || (cs == 'ZT03' && cs != 'ZT061'),
      changeMethod: 'changeMethod',
    },
    {
      prop: 'contractBusinessDepartment',
      name: '业务部门',
      type: 'select',
      options: ctx.departmentList,
      changeMethod: 'changeMethod',
      // disabled:
      //   (cs != '' && cs != 'ZT06' && cs != 'ZT05' && cs != 'ZT061') ||
      //   ctx.baseFormData.contractBusinessCompanyNo == '',
    },
    {
      prop: 'projectInitiationNo',
      name: '项目编号',
      searchType: 'projectInitiation',
      type: 'searchTableSpec',
      isMultiple: true,
      // disabled: cs != '' && cs != 'ZT06' && cs != 'ZT05' && cs != 'ZT061',
      currentValue: ctx.baseFormData.projectInitiationNo,
      // checkRowKeys: [ctx.baseFormData.projectInitiationNo],
      extraData: {
        projectInitiationStatusList: ['PIS04', 'PIS05', 'PIS07', 'PIS08'],
        // applyCompanyNo: ctx.baseFormData.contractBusinessCompanyNo,
        // applyDepartmentNo: ctx.baseFormData.contractBusinessDepartment,
        // platformtCompany: ctx.baseFormData.contractBusinessCompanyNo,
        // recyclingtCompany: ctx.baseFormData.contractBusinessCompanyNo,
        // applyDepartmentName: ctx.baseFormData.contractBusinessDepartmentName,
        // applyCompanyName: ctx.baseFormData.contractBusinessCompanyName,
        // platformtCompanyName: ctx.baseFormData.contractBusinessCompanyName,
        // recyclingtCompanyName: ctx.baseFormData.contractBusinessCompanyName,
      },
      changeMethod: 'changeMethod',
    },

    {
      prop: 'projectName',
      name: '项目简称',
      type: 'input',
      disabled: true,
      placeholder: '自动带出项目简称',
    },
    {
      prop: 'customerName',
      name: '客户名称',
      type: 'searchTableSpec',
      searchType: 'partner',
      placeholder: '请输入客户名称',
      isMultiple: true,
      // disabled: cs != '' && cs != 'ZT06' && cs != 'ZT05' && cs != 'ZT061',
      currentValue: ctx.baseFormData.customerName,
      extraData: customerExtraData,
      changeMethod: 'changeMethod',
    },
    // {
    //   prop: 'contractBusinessDepartmentName',
    //   name: '业务部门',
    //   type: 'select',
    //   options: ctx.departmentList,
    //   changeMethod: 'changeMethod',
    //   disabled: (cs != '' && cs != 'ZT06' && cs != 'ZT05') || ctx.baseFormData.companyCode == '',
    // },
    {
      prop: 'signDate',
      name: '合同签署日期',
      type: 'date',
      // disabled:
      // cs != '' && cs != 'ZT06' && cs != 'ZT05' && cs != 'ZT051' && cs != 'ZT021' && cs != 'ZT061',
    },
    {
      prop: 'contractValidStart',
      name: '合同生效日期',
      type: 'date',
      changeMethod: 'changeMethod',
      // disabled:
      //   cs != '' && cs != 'ZT06' && cs != 'ZT05' && cs != 'ZT051' && cs != 'ZT021' && cs != 'ZT061',
    },
    {
      prop: 'contractValidEnd',
      name: '合同到期日期',
      type: 'date',
      changeMethod: 'changeMethod',
      // disabled:
      //   cs != '' && cs != 'ZT06' && cs != 'ZT05' && cs != 'ZT051' && cs != 'ZT021' && cs != 'ZT061',
    },
    {
      prop: 'contractOperaterName',
      name: '操作人',
      type: 'input',
      disabled: true,
    },
    {
      prop: 'recyclingCompanyFileNo',
      name: '回收公司',
      type: 'select',
      options: ctx.recyclingCompanyFileList,
      changeMethod: 'changeMethod',
      // disabled: cs != '' && cs != 'ZT06' && cs != 'ZT05' && cs != 'ZT061',
    },
    {
      prop: 'recyclingCompanyFileNo',
      name: '回收公司档案编号',
      type: 'input',
      disabled: true,
    },
    {
      prop: 'platformCompanyFileNo',
      name: '平台公司',
      type: 'select',
      options: ctx.platformCompanyFileList,
      changeMethod: 'changeMethod',
      // disabled: cs != '' && cs != 'ZT06' && cs != 'ZT05' && cs != 'ZT061',
    },
    {
      prop: 'platformCompanyFileNo',
      name: '平台公司档案编号',
      type: 'input',
      disabled: true,
    },
    {
      prop: 'isFixedPrice',
      name: '不定价',
      type: 'checkbox',
      falseLable: '0',
      trueLable: '1',
      disabled: true,
      changeMethod: 'changeMethod',
    },
    {
      prop: 'contractCurrency',
      type: 'ajaxSelect',
      name: '币种',
      apiUrl: AGENCY_API.LIST_CURRENCY,
      method: 'get',
      apiData: { isEnabled: 1 },
      valueKey: 'currencyCode',
      moreShowKey: 'currencyCode',
      labelKey: 'currencyName',
      valueType: 'object',
      changeMethod: 'changeMethod',
      // disabled: cs != '' && cs != 'ZT06' && cs != 'ZT05' && cs != 'ZT061',
    },
    {
      prop: 'personChargeName',
      name: '负责人',
      type: 'searchTableSpec',
      searchType: 'personnel',
      isMultiple: true,
      currentValue: ctx.baseFormData.personChargeName,
      // disabled:
      //   cs != '' && cs != 'ZT06' && cs != 'ZT05' && cs != 'ZT051' && cs != 'ZT021' && cs != 'ZT061',
      changeMethod: 'changeMethod',
    },
    {
      prop: 'receiptMethod',
      name: '收款方式',
      type: 'select',
      label: 'label',
      value: 'value',
      options: ctx.dictListMap?.apply_payment_method || [],
      // disabled:
      //   cs != '' && cs != 'ZT06' && cs != 'ZT05' && cs != 'ZT051' && cs != 'ZT021' && cs != 'ZT061',
    },

    {
      prop: 'contractTotalAmount',
      name: '合同总金额',
      type: 'inputNumber',
      precision: 6,
      // disabled: true,
      placeholder: '请输入合同总金额',
    },
    {
      prop: 'overShippedPercentage',
      name: '溢装比例',
      type: 'inputNumber',
      max: 100,
      // disabled:
      //   cs != '' && cs != 'ZT06' && cs != 'ZT05' && cs != 'ZT051' && cs != 'ZT021' && cs != 'ZT061',
      append: '%',
    },
    {
      prop: 'shortShippedPercentage',
      name: '短装比例',
      type: 'inputNumber',
      max: 100,
      // disabled:
      //   cs != '' && cs != 'ZT06' && cs != 'ZT05' && cs != 'ZT051' && cs != 'ZT021' && cs != 'ZT061',
      append: '%',
    },
    {
      prop: 'performanceBondPayMethodCode',
      name: '履约保证金缴纳方式',
      type: 'select',
      options: ctx.dictListMap?.performance || [],
      // disabled:
      //   cs != '' && cs != 'ZT06' && cs != 'ZT05' && cs != 'ZT051' && cs != 'ZT021' && cs != 'ZT061',
      changeMethod: 'changeMethod',
    },
    {
      prop: 'performanceBond',
      name: '履约保证金',
      // disabled:
      //   cs != '' && cs != 'ZT06' && cs != 'ZT05' && cs != 'ZT051' && cs != 'ZT021' && cs != 'ZT061',
      type: 'inputNumber',
      placeholder: '请输入履约保证金',
    },
    {
      prop: 'marginAmount',
      name: '项目保证金',
      type: 'inputNumber',
      placeholder: '请输入项目保证金',
      append: '元',
    },
    {
      prop: 'warrantyClause',
      name: '保供条款',
      type: 'input',
      // disabled:
      //   cs != '' && cs != 'ZT06' && cs != 'ZT05' && cs != 'ZT051' && cs != 'ZT021' && cs != 'ZT061',
      placeholder: '请输入保供条款',
    },
    {
      prop: 'isRestrict',
      name: '是否定量',
      type: 'select',
      changeMethod: 'changeMethod',
      options: [
        {
          value: '0',
          label: '否',
        },
        {
          value: '1',
          label: '是',
        },
      ],
      // disabled:
      //   (cs != '' &&
      //     cs != 'ZT06' &&
      //     cs != 'ZT05' &&
      //     cs != 'ZT051' &&
      //     cs != 'ZT021' &&
      //     cs != 'ZT061') ||
      //   ctx.disabledIsRestrict,
    },
    {
      prop: 'externalContractNo',
      name: '外部合同号',
      type: 'input',
      placeholder: '请输入外部合同号',
    },
    {
      prop: 'mark',
      name: '备注',
      type: 'textarea',
      span: 24,
      maxlength: 512,
      // disabled:
      //   cs != '' && cs != 'ZT06' && cs != 'ZT05' && cs != 'ZT051' && cs != 'ZT021' && cs != 'ZT061',
    },
  ];
};

export const baseFormRule = (ctx) => {
  // let projectRequired = true;
  // if (COMPANY_CODE1.includes(ctx.baseFormData.companyCode)) {
  //   projectRequired = false;
  // }

  // if (ctx.baseFormData.isRelatedParty == 'Y') {
  //   projectRequired = false;
  // }

  return {
    contractName: [{ required: true, message: '必填字段', trigger: 'blur' }],
    customerName: [{ required: true, message: '必填字段', trigger: 'change' }],
    // projectInitiationNo: [{ required: projectRequired, message: '必填字段', trigger: 'change' }],
    personChargeName: [{ required: true, message: '必填字段', trigger: 'change' }],
    contractBusinessCompanyNo: [{ required: true, message: '必填字段', trigger: 'change' }],
    contractBusinessDepartment: [{ required: true, message: '必填字段', trigger: 'change' }],
    // recyclingCompanyFileNo: [{ required: true, message: '必填字段', trigger: 'blur' }],
    // platformCompanyFileNo: [{ required: true, message: '必填字段', trigger: 'blur' }],
    contractCurrency: [{ required: true, message: '必填字段', trigger: 'change' }],
    isRestrict: [{ required: true, message: '必填字段', trigger: ['blur'] }],
    contractValidEnd: [
      {
        required: COMPANY_CODE1.includes(ctx.baseFormData.contractBusinessCompanyNo) ? true : false, // 只要城矿公司需要校验
        message: '必填字段',
        trigger: 'blur',
      },
    ],
    contractValidStart: [
      {
        required: COMPANY_CODE1.includes(ctx.baseFormData.contractBusinessCompanyNo) ? true : false, // 只要城矿公司需要校验
        message: '必填字段',
        trigger: 'blur',
      },
    ],
    signDate: [
      {
        required: COMPANY_CODE1.includes(ctx.baseFormData.contractBusinessCompanyNo) ? true : false, // 只要城矿公司需要校验
        message: '必填字段',
        trigger: 'blur',
      },
    ],
  };
};
